import { render, staticRenderFns } from "./productExtraPrice.vue?vue&type=template&id=e5f0c1e2&scoped=true"
import script from "./productExtraPrice.vue?vue&type=script&lang=js"
export * from "./productExtraPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f0c1e2",
  null
  
)

export default component.exports